<div [formGroup]="configFormGroup">
  <h2>Note Config</h2>
  <div dwRow>
    <div dwCol="6">
      <label>Note Table</label>
      <select formControlName="NoteTable" class="form-control">
        <option *ngFor="let attr of tableMetaData" [ngValue]="attr.UniqueItemName">
          {{ attr.SchemaName }} : {{ attr.Display }}
        </option>
      </select>
    </div>
  </div>
  <div dwRow>
    <div dwCol="6">
      <label>Note Foreign Key</label>
      <select formControlName="NoteKey" class="form-control">
        <option *ngFor="let attr of itemMetaData?.Attributes" [ngValue]="attr.AttributeName">
          {{ attr.Display }}
        </option>
      </select>
    </div>
  </div>
  <div dwRow>
    <div dwCol="6">
      <label>Note Field</label>
      <select formControlName="NoteField" class="form-control">
        <option *ngFor="let attr of itemMetaData?.Attributes" [ngValue]="attr.AttributeName">
          {{ attr.Display }}
        </option>
      </select>
    </div>
  </div>
  <div dwRow>
    <div dwCol="6">
      <label>Delete Permission</label>
      <dw-security-permission-select formControlName="CanDeletePermissionMeaning">
      </dw-security-permission-select>
    </div>
  </div>
  <div dwRow>
    <div dwCol="6">
      <label>Save Note on Subject Switch</label>
      <input type="checkbox" formControlName="SaveOnSwitch" class="form-control">
    </div>
  </div>

</div>
